/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Component } from 'react';
import { GetDateInCurrentTimeZone } from '../../../lib/PublicFunctions';
import axios from 'axios';
import Button from '../../ui/Button';
import Dropdown from '../../ui/Dropdown';
import TextField from '../../ui/TextField';
import colors from '../../../css/colors';
import CurrencyField from '../../ui/CurrencyField';
import ToggleButton from '../../ui/ToggleButton';
import Select from 'react-select';
import ActionButton from 'components/ui/ActionButton';
import { Label } from 'semantic-ui-react';

const boxWrap = {
  border: `1px solid ${colors.grey}`,
  borderRadius: 5,
  padding: 24,
  flex: 1,
  '@media(min-width: 1260px)': {
    padding: 40,
  },
};

const inputStyles = {
  alignItems: 'center',
  backgroundColor: colors.greyOrder,
  borderRadius: 5,
  display: 'flex',
  height: 48,
  marginTop: 7,
  paddingLeft: 16,
  // width: 330,
};

const buttonStyles = {
  height: 40,
  minWidth: 0,
  width: 56,
};

export const dollarFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

export default class GeneralInfoSection extends Component {
  state = {
    isEdit: false,
    order: {},
    clients: [],
    saveButtonLoadingStatus: false,
    toggleOn: false,
    isSuperRushToggle: false,
    title: null,
  };
  async componentDidMount() {
    this.props.onLoadStatusChanged('GeneralInfo', true);
    try {
      const clientRequest = axios.get('/api/clients/getall').catch(error => {
        console.error('Failed to load clients', error);
        return { data: [] };
      });
      const [orderResponse, clientResponse] = await Promise.all([
        axios.get(`/api/orders/getorderdetails/${this.props.orderId}`),
        clientRequest,
      ]);
      const order = orderResponse.data || {};
      const clients = Array.isArray(clientResponse.data) ? clientResponse.data : [];
      this.setState({
        clients,
        order,
        toggleOn: order.isRush || false,
        isSuperRushToggle: order.isSuperRush || false,
      });
      this.props.setIsPurchase(order.isPurchase);
      this.props.setTitleNumber(order.titleNumber);
    } catch (error) {
      console.error('Failed to load general info', error);
    } finally {
      this.props.onLoadStatusChanged('GeneralInfo', false);
    }
  }

  handleSaveGeneralInfo = async () => {
    this.setState({ saveButtonLoadingStatus: true });
    const { order, isEdit } = this.state;
    await axios.post(`/api/orders/updategeneralinfo/${order.id}`, {
      clientId: order.clientId,
      titleNumber: order.titleNumber,
      overnightFee: order.overnightFee,
      isRush: this.state.toggleOn,
      isSuperRush: this.state.isSuperRushToggle,
    });
    this.setState({ isEdit: !isEdit });
    this.setState({ saveButtonLoadingStatus: false });
  };

  render() {
    const { isEdit, order, saveButtonLoadingStatus } = this.state;
    const clients = Array.isArray(this.state.clients) ? this.state.clients : [];
    const selectOptions = clients.map(c => ({
      label: c.name,
      value: c.id,
    }));

    return (
      <div css={boxWrap}>
        <div css={{ display: 'flex', justifyContent: 'space-between' }}>
          {this.state.order.ytPriority && (
            <Label color="blue" ribbon style={{ left: -54, top: 7, height: 27 }}>
              YT Priority
            </Label>
          )}
          <p
            css={{
              fontSize: 20,
              paddingTop: 7,
              position: this.state.order.ytPriority ? 'relative' : 'unset',
              left: this.state.order.ytPriority ? -75 : 'unset',
            }}
          >
            General
          </p>
          {isEdit || saveButtonLoadingStatus ? (
            <Button
              onClick={this.handleSaveGeneralInfo}
              overRidestyle={buttonStyles}
              loadingStatus={saveButtonLoadingStatus}
            >
              Save
            </Button>
          ) : (
            <Button overRidestyle={buttonStyles} onClick={() => this.setState({ isEdit: !isEdit })} secondary>
              Edit
            </Button>
          )}
        </div>
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <p css={{ color: colors.greyDark, marginBottom: 8 }}>Client</p>
          </div>
          {isEdit ? (
            // The value/placeholder should be the current client
            <Select
              options={selectOptions}
              width="330"
              defaultValue={selectOptions.find(c => c.value === order.clientId) || ''}
              onChange={client => {
                this.setState({
                  order: {
                    ...order,
                    clientName: client.label,
                    clientId: client.value,
                  },
                });
              }}
            />
          ) : (
            <p css={inputStyles}>
              {this.state.order.clientName}
              <ActionButton
                icon="InfoIcon"
                backgroundColor={colors.greyOrder}
                onClick={this.props.setClientInfoModalOpen}
                styles={{ height: 22, width: 22, marginLeft: 5, opacity: 0.6 }}
              />
            </p>
          )}
          <p css={{ color: colors.greyDark, marginTop: 16 }}>Title</p>
          {isEdit ? (
            // The value/placeholder should be the current title
            <TextField
              width="330"
              placeHolder={this.state.order.titleNumber}
              value={order.titleNumber}
              disabled={saveButtonLoadingStatus}
              onChange={e =>
                this.setState({
                  order: { ...order, titleNumber: e.target.value },
                })
              }
            />
          ) : (
            <p css={inputStyles}>{this.state.order.titleNumber}</p>
          )}
          <p css={{ color: colors.greyDark, marginTop: 16 }}>Overnight Fee</p>
          {isEdit ? (
            // The value/placeholder should be the current title
            <CurrencyField
              width="330"
              placeHolder={order.overnightFee}
              value={order.overnightFee}
              disabled={saveButtonLoadingStatus}
              onChange={val => this.setState({ order: { ...order, overnightFee: val } })}
            />
          ) : (
            <p css={inputStyles}>
              {order.overnightFee ? `${dollarFormatter.format(order.overnightFee)}` : ''}
            </p>
          )}
          {
            //tzvi newman
          }
          {isEdit && (
            <div style={{ marginTop: 16 }}>
              <span css={{ fontWeight: 'bold', textAlign: 'right', padding: 10 }}>Rush Order</span>
              <ToggleButton
                value={this.state.toggleOn}
                onToggle={toggleOn => {
                  this.setState({ toggleOn });
                  this.props.setIsRush(toggleOn);
                }}
              />
            </div>
          )}
          {isEdit && (
            <div style={{ marginTop: 16 }}>
              <span css={{ fontWeight: 'bold', textAlign: 'right', padding: 10 }}>Super Rush Order</span>
              <ToggleButton
                value={this.state.isSuperRushToggle}
                onToggle={isSuperRushToggle => {
                  this.setState({ isSuperRushToggle });
                  this.props.setIsSuperRush(isSuperRushToggle);
                }}
              />
            </div>
          )}
          <div style={{ marginTop: 16, display: 'flex' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div css={{ color: colors.greyDark, marginRight: 89 }}>Date</div>
              <div css={{ marginRight: 64 }}>
                {GetDateInCurrentTimeZone(this.state.order.orderDate).format('MM-DD-YY')}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div css={{ color: colors.greyDark }}>Hds</div>
              <div>{this.state.order.hdsNumber}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
